import { NoddiTimeField } from './NoddiTimeField';

export type NoddiTimeRangeProps = {
  value: { start: string; end: string };
  onChange: ({ start, end }: { start: string; end: string }) => void;
  min?: string;
  max?: string;
  startName?: string;
  endName?: string;
  startAriaDescribedBy?: string;
  endAriaDescribedBy?: string;
  startAriaInvalid?: boolean;
  endAriaInvalid?: boolean;
  startTooltip?: string;
  endTooltip?: string;
  /** Names what the range is of when a form has several, e.g. "Break start" beside the shift's own. */
  startLabel?: string;
  endLabel?: string;
};

export const NoddiTimeRange = ({
  value,
  onChange,
  min = '05:00',
  max = '23:00',
  startName = 'startTime',
  endName = 'endTime',
  startAriaDescribedBy,
  endAriaDescribedBy,
  startAriaInvalid,
  endAriaInvalid,
  startTooltip,
  endTooltip,
  startLabel = 'Start time',
  endLabel = 'End time'
}: NoddiTimeRangeProps) => {
  const handleStartTimeChange = (newStartTime: string) => {
    onChange({ start: newStartTime, end: value.end });
  };

  const handleEndTimeChange = (newEndTime: string) => {
    onChange({ start: value.start, end: newEndTime });
  };

  return (
    <div className='flex flex-wrap gap-4'>
      <NoddiTimeField
        name={startName}
        label={startLabel}
        aria-invalid={startAriaInvalid}
        aria-describedby={startAriaDescribedBy}
        value={value.start}
        onChange={handleStartTimeChange}
        min={min}
        max={max}
        className='min-w-30'
        tooltip={startTooltip}
      />
      <NoddiTimeField
        name={endName}
        label={endLabel}
        aria-invalid={endAriaInvalid}
        aria-describedby={endAriaDescribedBy}
        value={value.end}
        onChange={handleEndTimeChange}
        min={min}
        max={max}
        className='min-w-30'
        tooltip={endTooltip}
      />
    </div>
  );
};
